import { type QuizGetInput, type QuizGetSuccess, type QuizId } from '@terros/common'
import { useTantalimQuery } from '../query'
import { quizKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useQuiz(quizId: QuizId): GetHookResponse<QuizGetSuccess> {
  return useTantalimQuery<QuizGetInput, QuizGetSuccess, QuizGetSuccess>({
    url: '/quiz/get',
    queryKey: quizKey(quizId),
    input: { quizId },
    convertResponse: (data) => data,
  })
}
